var divider_viewer_rtlignore_default = {
  "divider-container": "wl06Y",
  "divider-container--double": "_5B2r-",
  "divider": "CPWDy",
  "divider--single": "QbWsv",
  "divider--double": "_7SDGH",
  "divider--dashed": "_9IvCV",
  "divider--dotted": "Vw8LH",
  "divider--small": "_2BzEB",
  "divider--small--mobile": "vyIGb",
  "divider--medium": "k-0ch",
  "divider--large--mobile": "EFSIt",
  "divider--medium--mobile": "mfVnV",
  "divider--large": "_8Tu4J",
  "divider--left": "_58uqn",
  "divider--center": "_2a5aw",
  "divider--right": "RFwpP",
  "divider--fill-parent": "JBWAU",
  "svgFixerContainer": "HgG-o",
  "emptyChar": "gSmO4"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
